@if (checkingTokenValidity$ | async) {
    <mat-progress-spinner mode="indeterminate" diameter="40" color="gray" style="display: inline-block" />
} @else {
    <app-base-page title="Enter new password">
        <p class="mb-30">Setup new password for you account and confirm</p>

        @if (isTokenValid$ | async) {
            <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
                <app-password-visibility>
                    <adc-input
                        #control
                        type="password"
                        class="text-form-control block"
                        placeholder="Enter password"
                        formControlName="password"
                        autocomplete="new-password"
                        [errorMessages]="passwordErrorMessages"
                    />
                </app-password-visibility>

                <app-password-visibility>
                    <adc-input
                        #control
                        type="password"
                        class="text-form-control block"
                        placeholder="Confirm password"
                        formControlName="confirmPassword"
                        autocomplete="new-password"
                        [errorMessages]="confirmPasswordErrorMessages"
                    />
                </app-password-visibility>

                <div class="actions">
                    <adc-button
                        type="primary"
                        size="40"
                        class="submit-button"
                        [isSubmit]="true"
                        [disabled]="submissionProcessing$ | async"
                    >
                        @if (submissionProcessing$ | async) {
                            <mat-progress-bar mode="indeterminate" />
                        }
                        Submit
                    </adc-button>
                </div>

                @if (passwordErrorMessage$ | async; as message) {
                    <mat-error class="mt-10">
                        {{ message }}
                    </mat-error>
                }
            </form>
        } @else {
            <mat-error>Token is invalid</mat-error>

            <div class="actions">
                <adc-button type="primary" size="40" class="submit-button" routerLink="/login" (click)="onGotoLogin()">
                    Go to login
                </adc-button>
            </div>
        }
    </app-base-page>
}
